module.exports = __webpack_public_path__ + "img/arrow-up.5a344b90.svg";